<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<p class="firstInSection">To my husband Ian, adjusting to having a writer in the family.</p>
<p>Also to Elaine Everest, tutor at The Write Place Creative Writing School at Hextable, and to my group of writing buddies there. They have given me so much help and encouragement, and together we have enjoyed often hilarious social events.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?6aae0247